import { render, staticRenderFns } from "./PasswordResetSetPasswordForm.vue?vue&type=template&id=0d5baf1f&"
import script from "./PasswordResetSetPasswordForm.vue?vue&type=script&lang=js&"
export * from "./PasswordResetSetPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports